import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["oidcUser", "oidcIsAuthenticated"])
  },
  methods: {
    ...mapActions(["authenticateOidc", "removeOidcUser", "signOutOidc"]),
    signIn() {
      this.authenticateOidc({
        redirectPath: this.$route.fullPath
      });
    },
    signOut() {
      this.signOutOidc({
        post_logout_redirect_uri: window.location
      });
    }
  }
};
